import { MENU_ITEMS } from 'constants/sidebar';
import { useLocation } from 'react-router-dom';
import styles from './styles.module.scss';

function HeaderSectionIcon() {
  const location = useLocation();

  return null;

  // const Icon = MENU_ITEMS.find(
  //   (el) =>
  //     el?.url === location?.pathname ||
  //     el.subItem.find((item) => item?.url === location?.pathname)
  // )?.icon;

  // if (!!Icon) {
  //   return <Icon className={styles.header_section_icon} />;
  // } else {
  //   return null;
  // }
}

export default HeaderSectionIcon;
